export default [
{
    path: "/Report/PermitReport",
    name: "PermitReport",
    component:  () => import("@/components/Report/PermitReport.vue"),
    meta: {
        name: "PermitReport",
        menuTitle: "Permit Report",
    },
    props: true
},
{
    path: "/Report/WorkReport",
    name: "WorkReport",
    component:  () => import("@/components/Report/WorkReport.vue"),
    meta: {
        name: "WorkReport",
        menuTitle: "Work Report",
    },
    props: true
},
];
